<mat-toolbar>
  <!-- Logo a la izquierda -->
  <div class="logo">
    <img *ngIf="perfil" [src]="perfil.pas_logo_base64" alt="Logo">
  </div>

  <!-- Menú de escritorio al centro -->

  <nav class="menu-desktop" *ngIf="!isMobile">
  <a mat-button routerLink="cotizador">Home</a>
  <a mat-button routerLink="descarga-poliza" class="destacado-poliza">
      Descargá tu póliza
    </a>
  <a mat-button routerLink="/preguntas-frecuentes">Preguntas Frecuentes</a>
  <!--<a mat-button routerLink="/siniestros">Siniestros</a>-->
  <!--<a mat-button routerLink="/contactos">Contactos</a>-->
  </nav>

  <span class="spacer"></span>

  <!-- Redes sociales SIEMPRE visibles y menú hamburguesa solo en mobile -->
  <div class="toolbar-right">
    <div class="social-icons" *ngIf="!isMobile">
      <a *ngIf="perfil?.pas_red_facebook" [href]="perfil?.pas_red_facebook" target="_blank">
        <fa-icon [ngStyle]="{'color': 'var(--primary-500)'}" [icon]="['fab', 'facebook-f']"></fa-icon>
      </a>
      <a *ngIf="perfil?.pas_red_instagram" [href]="perfil?.pas_red_instagram" target="_blank">
        <fa-icon [ngStyle]="{'color': 'var(--primary-500)'}" [icon]="['fab', 'instagram']"></fa-icon>
      </a>
      <a *ngIf="perfil?.pas_red_ln" [href]="perfil?.pas_red_ln" target="_blank">
        <fa-icon [ngStyle]="{'color': 'var(--primary-500)'}" [icon]="['fab', 'linkedin']"></fa-icon>
      </a>
      <a *ngIf="perfil?.pas_red_x" [href]="perfil?.pas_red_x" target="_blank">
        <fa-icon [ngStyle]="{'color': 'var(--primary-500)'}" [icon]="['fab', 'x-twitter']"></fa-icon>
      </a>
    </div>
    <!-- Menú hamburguesa solo en mobile -->

    <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-mobile" *ngIf="isMobile">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
  <button mat-menu-item routerLink="/cotizador">Home</button>
  <button mat-menu-item routerLink="/descarga-poliza">Descargá tu póliza</button>
  <button mat-menu-item routerLink="/preguntas-frecuentes">Preguntas Frecuentes</button>
  <!--<button mat-menu-item routerLink="/siniestros">Siniestros</button>-->
  <!--<button mat-menu-item routerLink="/contactos">Contactos</button>-->
    </mat-menu>

  </div>
</mat-toolbar>
